import { collection, addDoc, serverTimestamp, doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase'; // Adjust path to your Firebase config

export const sendSubmissionStatusEmail = async (submissionData, status, additionalMessage = '') => {
  try {
    
    
    // Fetch the course title using the course ID
    let courseTitle = submissionData.courseTitle || "Unknown Course";
    if (submissionData.courseId && !submissionData.courseTitle) {
      try {
        const courseDocRef = doc(db, 'courses', submissionData.courseId);
        const courseDoc = await getDoc(courseDocRef);
        if (courseDoc.exists()) {
          courseTitle = courseDoc.data().title;
         
        }
      } catch (error) {
        console.error('Error fetching course data:', error);
      }
    }

    // Fetch student data from students collection using student ID
    let studentEmail = null;
    let studentName = submissionData.studentName || 'Student';
    let studentData = null;
    
    // Try to get student ID from different possible field names
    const studentId = submissionData.studentId || submissionData.student_id || submissionData.userId;
    
    if (studentId) {
      try {
        
        const studentDocRef = doc(db, 'students', studentId);
        const studentDoc = await getDoc(studentDocRef);
        
        if (studentDoc.exists()) {
          studentData = studentDoc.data();
          studentEmail = studentData.email;
          studentName = studentData.name || studentData.firstName || studentName;
          
        } else {
          console.error(`Student document not found for ID: ${studentId}`);
          
        }
      } catch (error) {
        console.error(`Error fetching student data for ID ${studentId}:`, error);
      }
    } else {
      console.warn('No student ID found in submission data. Available fields:', Object.keys(submissionData));
    }

    // Fallback to submission data if student lookup failed
    if (!studentEmail) {
      studentEmail = submissionData.studentEmail || submissionData.email;
      console.warn('Using fallback email from submission data:', studentEmail);
    }

    if (!studentEmail) {
      const errorMsg = `Student email not found. StudentId: ${studentId}, Available fields: ${Object.keys(submissionData).join(', ')}`;
      console.error(errorMsg);
      throw new Error(errorMsg);
    }

    // Determine email content based on status
    const getStatusContent = (status) => {
      switch (status.toLowerCase()) {
        case 'approved':
          return {
            emoji: '🎉',
            statusColor: '#28a745',
            statusBg: '#d4edda',
            borderColor: '#c3e6cb',
            title: 'Submission Approved!',
            message: 'Congratulations! Your submission has been reviewed and approved.',
            icon: '✅',
            gradient: 'linear-gradient(135deg, #28a745 0%, #20c997 100%)'
          };
        case 'rejected':
          return {
            emoji: '📝',
            statusColor: '#dc3545',
            statusBg: '#f8d7da',
            borderColor: '#f5c6cb',
            title: 'Submission Needs Revision',
            message: 'Your submission has been reviewed and requires some improvements. Please review the feedback and resubmit.',
            icon: '❌',
            gradient: 'linear-gradient(135deg, #dc3545 0%, #fd7e14 100%)'
          };
        case 'pending':
          return {
            emoji: '⏳',
            statusColor: '#ffc107',
            statusBg: '#fff3cd',
            borderColor: '#ffeaa7',
            title: 'Submission Under Review',
            message: 'Your submission is currently being reviewed. You will receive another notification once the review is complete.',
            icon: '⏰',
            gradient: 'linear-gradient(135deg, #ffc107 0%, #fd7e14 100%)'
          };
        default:
          return {
            emoji: '📄',
            statusColor: '#6c757d',
            statusBg: '#f8f9fa',
            borderColor: '#dee2e6',
            title: 'Submission Status Update',
            message: 'There has been an update to your submission status.',
            icon: '📋',
            gradient: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)'
          };
      }
    };

    const statusContent = getStatusContent(status);

    

    const emailDoc = await addDoc(collection(db, 'mail'), {
      to: [studentEmail],
      message: {
        subject: `${statusContent.emoji} INTERSKOOL - ${statusContent.title}`,
        html: `
          <!DOCTYPE html>
          <html>
          <head>
            <style>
              body { 
                font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
                line-height: 1.6; 
                color: #333; 
                margin: 0; 
                padding: 0; 
                background-color: #f8f9fa; 
              }
              .container { 
                max-width: 900px; 
                margin: 0 auto; 
                padding: 20px; 
              }
              .header { 
                background: ${statusContent.gradient}; 
                color: white; 
                padding: 30px; 
                text-align: center; 
                border-radius: 15px 15px 0 0; 
                box-shadow: 0 4px 20px rgba(0,0,0,0.1);
              }
              .header h1 {
                margin: 0 0 10px 0;
                font-size: 2.2em;
                font-weight: 700;
              }
              .header h2 {
                margin: 5px 0;
                font-size: 1.8em;
                font-weight: 300;
                opacity: 0.9;
              }
              .content { 
                background: white; 
                padding: 40px; 
                border-radius: 0 0 15px 15px; 
                box-shadow: 0 4px 20px rgba(0,0,0,0.1);
              }
              .status-banner { 
                background: ${statusContent.statusBg}; 
                color: ${statusContent.statusColor};
                padding: 25px; 
                border-radius: 12px; 
                margin: 25px 0; 
                border-left: 6px solid ${statusContent.statusColor}; 
                box-shadow: 0 3px 15px rgba(0,0,0,0.1);
                text-align: center;
              }
              .status-banner h3 {
                margin: 0 0 10px 0;
                font-size: 1.5em;
                font-weight: 600;
              }
              .submission-details { 
                background: #f8f9fa; 
                padding: 25px; 
                border-radius: 12px; 
                margin: 25px 0; 
                border: 1px solid #e9ecef;
                box-shadow: 0 2px 10px rgba(0,0,0,0.05);
              }
              .submission-details h4 {
                color: #495057;
                margin: 0 0 15px 0;
                font-size: 1.2em;
                font-weight: 600;
              }
              .detail-row {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 8px 0;
                border-bottom: 1px solid #e9ecef;
              }
              .detail-row:last-child {
                border-bottom: none;
              }
              .detail-label {
                font-weight: 600;
                color: #6c757d;
                min-width: 120px;
              }
              .detail-value {
                color: #495057;
                text-align: right;
                flex-grow: 1;
              }
              .btn { 
                display: inline-block; 
                background: ${statusContent.gradient}; 
                color: white; 
                padding: 15px 35px; 
                text-decoration: none; 
                border-radius: 30px; 
                margin: 20px 0; 
                font-weight: 600;
                text-align: center;
                font-size: 1.1em;
                transition: transform 0.2s ease;
                box-shadow: 0 4px 15px rgba(0,0,0,0.2);
              }
              .btn:hover {
                transform: translateY(-2px);
              }
              .additional-message { 
                background: #e3f2fd; 
                padding: 20px; 
                border-radius: 10px; 
                border-left: 4px solid #2196f3; 
                margin: 20px 0;
                color: #1565c0;
              }
              .additional-message h4 {
                margin: 0 0 10px 0;
                color: #1565c0;
              }
              .next-steps {
                background: white;
                padding: 25px;
                border-radius: 12px;
                margin: 25px 0;
                border: 2px dashed #dee2e6;
              }
              .next-steps h4 {
                color: #495057;
                margin: 0 0 15px 0;
              }
              .steps-list {
                list-style: none;
                padding: 0;
                margin: 0;
              }
              .steps-list li {
                padding: 8px 0;
                position: relative;
                padding-left: 30px;
              }
              .steps-list li:before {
                content: counter(step-counter);
                counter-increment: step-counter;
                position: absolute;
                left: 0;
                top: 8px;
                background: ${statusContent.statusColor};
                color: white;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                font-weight: bold;
              }
              .steps-list {
                counter-reset: step-counter;
              }
              .footer { 
                text-align: center; 
                color: #6c757d; 
                margin-top: 40px; 
                padding-top: 20px;
                border-top: 1px solid #dee2e6;
                font-size: 14px; 
              }
              .footer p {
                margin: 5px 0;
              }
              .highlight {
                background: linear-gradient(120deg, #a8e6cf 0%, #dcedc1 100%);
                padding: 2px 8px;
                border-radius: 4px;
                font-weight: 600;
              }
              .student-info {
                background: #e8f5e8;
                padding: 15px;
                border-radius: 8px;
                margin: 15px 0;
                border-left: 4px solid #28a745;
              }
            </style>
          </head>
          <body>
            <div class="container">
              <div class="header">
                <h1>${statusContent.icon} ${statusContent.title}</h1>
                <h2>INTERSKOOL</h2>
                <p>Submission Review Notification</p>
              </div>
              
              <div class="content">
                <h2>Hello ${studentName}! 👋</h2>
                ${studentData && studentId ? `
                <div class="student-info">
                  <strong>Student ID:</strong> ${studentId}
                </div>
                ` : ''}
                <p>We have completed the review of your recent submission and wanted to update you on its status.</p>
                
                <div class="status-banner">
                  <h3>${statusContent.icon} Status: <span class="highlight">${status.toUpperCase()}</span></h3>
                  <p style="margin: 0; font-size: 1.1em;">${statusContent.message}</p>
                </div>
                
                <div class="submission-details">
                  <h4>📋 Submission Details</h4>
                  <div class="detail-row">
                    <span class="detail-label">📚 Course:</span>
                    <span class="detail-value">${courseTitle}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">📅 Day:</span>
                    <span class="detail-value">${submissionData.dayId || 'N/A'}</span>
                  </div>
                  <div class="detail-row">
                    <span class="detail-label">📤 Submitted:</span>
                    <span class="detail-value">${submissionData.submittedAt ? new Date(
                      submissionData.submittedAt.seconds
                        ? submissionData.submittedAt.seconds * 1000
                        : submissionData.submittedAt
                    ).toLocaleString() : 'N/A'}</span>
                  </div>
                  ${submissionData.githubRepoUrl ? `
                  <div class="detail-row">
                    <span class="detail-label">🔗 Repository:</span>
                    <span class="detail-value"><a href="${submissionData.githubRepoUrl}" target="_blank" style="color: #0366d6;">View on GitHub</a></span>
                  </div>
                  ` : ''}
                </div>
                
                ${additionalMessage ? `
                <div class="additional-message">
                  <h4>💬 Additional Feedback</h4>
                  <p style="margin: 0;">${additionalMessage}</p>
                </div>
                ` : ''}
                
                ${status.toLowerCase() === 'approved' ? `
                <div class="next-steps">
                  <h4>🎯 What's Next?</h4>
                  <ol class="steps-list">
                    <li>Continue with your next assignment or module</li>
                    <li>Check your dashboard for upcoming tasks</li>
                    <li>Keep up the excellent work!</li>
                  </ol>
                </div>
                ` : status.toLowerCase() === 'rejected' ? `
                <div class="next-steps">
                  <h4>🔄 Next Steps for Resubmission</h4>
                  <ol class="steps-list">
                    <li>Review the feedback provided above</li>
                    <li>Make the necessary improvements to your work</li>
                    <li>Resubmit your assignment through the platform</li>
                    <li>Contact your instructor if you need clarification</li>
                  </ol>
                </div>
                ` : ''}
                
                <div style="text-align: center; margin: 30px 0;">
                  <a href="https://internskool-front.vercel.app/authentication" class="btn">
                    🚀 Access Your Dashboard
                  </a>
                </div>
              </div>
              
              <div class="footer">
                <p><strong>Need Help?</strong> Contact our support team if you have any questions.</p>
                <p>This is an automated message. Please do not reply to this email.</p>
                <p>&copy; 2025 INTERSKOOL. All rights reserved.</p>
                <p>🌟 Empowering education, one student at a time</p>
              </div>
            </div>
          </body>
          </html>
        `
      },
      createdAt: serverTimestamp(),
      // Add metadata for debugging
      metadata: {
        studentId: studentId,
        studentEmail: studentEmail,
        submissionId: submissionData.id,
        status: status,
        timestamp: new Date().toISOString()
      }
    });
    
    
    return { 
      success: true, 
      emailId: emailDoc.id,
      studentEmail: studentEmail,
      studentName: studentName 
    };
  } catch (error) {
    console.error('Error queuing submission status email:', error);
    return { success: false, error: error.message };
  }
};

// Convenience functions for specific statuses
export const sendApprovalEmail = (submissionData, additionalMessage = '') => {
  return sendSubmissionStatusEmail(submissionData, 'approved', additionalMessage);
};

export const sendRejectionEmail = (submissionData, additionalMessage = '') => {
  return sendSubmissionStatusEmail(submissionData, 'rejected', additionalMessage);
};

export const sendPendingEmail = (submissionData, additionalMessage = '') => {
  return sendSubmissionStatusEmail(submissionData, 'pending', additionalMessage);
};


